import { render, staticRenderFns } from "./ProjectFieldFormGroup.vue?vue&type=template&id=a404f8a8"
import script from "./ProjectFieldFormGroup.vue?vue&type=script&lang=js"
export * from "./ProjectFieldFormGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports